import { Route, Routes } from "react-router-dom";
import LoginPage from "./LoginPage";

export default function AuthPage() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route index element={<LoginPage />} />
    </Routes>
  );
}
